import Clock from './Clock/Clock';
import Hand from './Hand/Hand';
import Numeral from './Numeral/Numeral';

export{
  Hand,
  Clock,
  Numeral
}
